/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

const { CrudApi } = require("./crudApi");

class NotesApi extends CrudApi {
    constructor() {
        super("notes");
    }

    fetchComments(id, config) {
        return this.request
            .get(this.url, {
                params: {
                    include: [
                        "annotation.*",
                        "created_by.*",
                        "status.*",
                        "to.*",
                        "tasks.*",
                        "note_links.*",
                        "uploaded_files.*",
                        "project",
                    ],
                    "filter{trash}": false,
                    "filter{note_links.in}": id,
                    ...config,
                },
            })
            .then(({ data }) => data);
    }
}

export const notesApi = new NotesApi();
